// Module key
const KEY_MODULE = '[USER]: ';

export const USER_LOGIN_SUCCESS = `${KEY_MODULE} LOGIN_SUCCESS`;
export const USER_LOGIN_FAILURE = `${KEY_MODULE} LOGIN_FAILURE`;
export const USER_LOGOUT = `${KEY_MODULE} LOGOUT`;